import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'TrustTrusteesSearch',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                trust_number: '',
                masters_office: ''
            }
        };
    },
    emits: ['service_status_complete'],
    methods: {
        submit_trust_trustees() {
            if (!this.form.trust_number.trim() || !this.form.masters_office.trim()) {
                this.showError('Error', 'Both Trust Number and Master\'s Office are required');
                return false;
            }
            const trust_number_regex = /^\d{6}\/\d{4}$/;
            if (!trust_number_regex.test(this.form.trust_number)) {
                this.showError('Error', 'Trust Number must be in the format 000000/YYYY');
                return false;
            }
            this.trust_trustees_search_api();
        },
        trust_trustees_search_api() {
            const TOKEN = localStorage.getItem('token');
            const TRUSTEES_SEARCH_API = `${API_BASE_URL}/verify_api/instant_verify_api/trust_trustees_search/`;

            $.ajax({
                url: TRUSTEES_SEARCH_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    trust_number: this.form.trust_number,
                    masters_office: this.form.masters_office
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Trustees Found Successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.trust_number = '';
                    this.form.masters_office = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        }
    },
    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
